import DropdownTemplateView from "../../../../DropdownTemplateView"

export default class ConfirmationDropdown extends DropdownTemplateView {
    constructor() {
        super()
    }

    templateHtml() {
        return "<div class='leaveBlackoutConfirmation atNextMount' />"
    }

    afterRender() {
        this.$confirmationComponent = ClassicBridge.integrateMarkAsLeaveBlackoutConfirmation(
            this.$el[0],
            {
                onCancel: () => this.hide(),
            }
        )
        this.renderInitialState()
    }

    setProps(date, onConfirmCallback, nonApprovedLeaveRequestsCount) {
        this.$confirmationComponent.setProps({
            date: date,
            rejectedCount: nonApprovedLeaveRequestsCount,
            onConfirm: () => {
                onConfirmCallback()
                this.hide()
            },
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/ConfirmationDropdown.js